/* eslint-disable no-unused-vars */
import React, {Component} from "react";
import {InputLabel, withStyles, Select, MenuItem} from "@material-ui/core";
import classNames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import {API} from "../../../config";
import Util from "../../../yeffect/utils";

const country = API.service('country');

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class CountrySelect extends Component {
    state = {
        active:     this.props.active || 1,
        countries:  false,
        options:    false,
    };

    updateOptions = () => {
        const app = this;

        let options = [];

        if(this.props.categoryValue === 'E'){

            if(this.props.groupValue === 'S'
                || this.props.groupValue === 'C'
                || this.props.groupValue === 'L'
                || this.props.groupValue === 'P'
                || this.props.groupValue === 'F'
                || this.props.groupValue === 'D'
                || this.props.groupValue === 'M'
            ) {
                options.push(
                    {value: 'B', label: 'B: Bearer'},
                    {value: 'R', label: 'R: Registered'},
                    {value: 'N', label: 'N: Bearer/Registered'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'Y'
            ) {
                options.push(
                    {value: 'B', label: 'B: Baskets'},
                    {value: 'S', label: 'S: Equities'},
                    {value: 'D', label: 'D: Debt Instruments'},
                    {value: 'G', label: 'G: Derivatives'},
                    {value: 'T', label: 'T: Commodities'},
                    {value: 'C', label: 'C: Currencies'},
                    {value: 'I', label: 'I: Indices'},
                    {value: 'N', label: 'N: Interest Rates'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }
        }

        if(this.props.categoryValue === 'D'){

            if(this.props.groupValue === 'B'
                || this.props.groupValue === 'C'
                || this.props.groupValue === 'W'
                || this.props.groupValue === 'T'
                || this.props.groupValue === 'Y'
                || this.props.groupValue === 'G'
                || this.props.groupValue === 'A'
                || this.props.groupValue === 'N'
                || this.props.groupValue === 'M'
            ) {
                options.push(
                    {value: 'B', label: 'B: Bearer'},
                    {value: 'R', label: 'R: Registered'},
                    {value: 'N', label: 'N: Bearer/Registered'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'D') {
                options.push(
                    {value: 'F', label: 'F: Fixed Maturity'},
                    {value: 'G', label: 'G: Fixed Maturity with Call Feature'},
                    {value: 'C', label: 'C: Fixed Maturity with Put Feature'},
                    {value: 'D', label: 'D: Fixed Maturity with Put and Call'},
                    {value: 'A', label: 'A: Amortization Plan'},
                    {value: 'B', label: 'B: Amortization Plan with Call Feature'},
                    {value: 'T', label: 'T: Amortization Plan with Put Feature'},
                    {value: 'L', label: 'L: Amortization Plan with Put and Call'},
                    {value: 'P', label: 'P: Perpetual'},
                    {value: 'Q', label: 'Q: Perpetual with Call Feature'},
                    {value: 'R', label: 'R: Perpetual with Put Feature'},
                    {value: 'E', label: 'E: Extendible'},
                )
            }
            if(this.props.groupValue === 'S'
                || this.props.groupValue === 'E'
            ){
                options.push(
                    {value: 'B', label: 'B: Baskets'},
                    {value: 'S', label: 'S: Equities'},
                    {value: 'D', label: 'D: Debt Instruments'},
                    {value: 'T', label: 'T: Commodities'},
                    {value: 'C', label: 'C: Currencies (Specified Exchange Rate)'},
                    {value: 'I', label: 'I: Indices (The Performance of an Index)'},
                    {value: 'N', label: 'N: Interest Rates'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }
        }

        if(this.props.categoryValue === 'C') {

            if (this.props.groupValue === 'H'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }

            if (this.props.groupValue === 'I'
                || this.props.groupValue === 'F'
                || this.props.groupValue === 'P'
                || this.props.groupValue === 'M'
                || this.props.groupValue === 'B'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'S',label:'S: Shares'},
                        {value:'Q',label:'Q: Shares for QI'},
                        {value:'U',label:'U: Units'},
                        {value:'Y',label:'Y: Units for QI'},
                    )
                }
            }

            if (this.props.groupValue === 'E'
                || this.props.groupValue === 'S'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'S',label:'S: Shares'},
                        {value:'U',label:'U: Units'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'R') {

            if (this.props.groupValue === 'M'
            //|| this.props.groupValue === 'S'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }

            if (this.props.groupValue === 'A'
                || this.props.groupValue === 'S'
                || this.props.groupValue === 'P'
                || this.props.groupValue === 'D'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'B',label:'B: Bearer'},
                        {value:'R',label:'R: Registered'},
                        {value:'N',label:'N: Bearer/Registered'},
                        {value:'M',label:'M: Others(Miscellaneous)'},
                    )
                }
            }

            if (this.props.groupValue === 'W'
                || this.props.groupValue === 'F'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'E',label:'E: European'},
                        {value:'A',label:'A: American'},
                        {value:'B',label:'B: Bermudan'},
                        {value:'M',label:'M: Others(Miscellaneous)'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'O') {

            if (this.props.groupValue === 'M'
            //|| this.props.groupValue === 'S'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }

            if (this.props.groupValue === 'C'
                || this.props.groupValue === 'P'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'S',label:'S: Standardized'},
                        {value:'N',label:'N: Non-Standardized'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'F') {

            if (this.props.groupValue === 'F'
                || this.props.groupValue === 'C'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'T') {

            if (this.props.groupValue === 'T'
                || this.props.groupValue === 'C'
                || this.props.groupValue === 'R'
                || this.props.groupValue === 'I'
                || this.props.groupValue === 'B'
                || this.props.groupValue === 'D'
                || this.props.groupValue === 'M'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'M') {

            if (this.props.groupValue === 'M'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }

            if (this.props.groupValue === 'C'
            ) {
                if (this.props.lvl3Value    !== ''

                ) {
                    options.push(
                        {value:'B',label:'B: Bearer'},
                        {value:'R',label:'R: Registered'},
                        {value:'N',label:'N: Bearer/Registered'},
                        {value:'M',label:'M: Others(Miscellaneous)'},
                    )
                }
            }
        }

        app.setState({
            options: options
        })
    }

    componentDidMount() {
        this.updateOptions();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(this.props.categoryValue !== prevProps.categoryValue || this.props.groupValue !== prevProps.groupValue){
            this.updateOptions();
        }
    }

    render() {
        const { classes, possibleValues, value, width, onChange, fieldLabel, fieldName, errorFields, categoryValue} = this.props;
        const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <FormControl className={classNames('w-full')} >
                        <InputLabel shrink={(!Util.isEmpty(value) || value === false)} id={fieldName + '_label'}>{fieldLabel} {(this.props.required === true) ? '*' :''}</InputLabel>
                        <Select
                            labelId={fieldName + '_label'}
                            id={fieldName}
                            value={value}
                            label="Age"
                            name={fieldName}
                            onChange={onChange}
                            error={!(typeof errorFields[fieldName] === "undefined")}
                            helperText={(typeof errorFields[fieldName] !== "undefined") ? errorFields[fieldName] : false}
                            required={this.props.required}
                            >


                            <option value=""> </option>
                            {(this.state.options !== false) &&
                            this.state.options.map(o => {
                                return (
                                    <MenuItem value={o.value}>{o.label}</MenuItem>
                                )

                            })
                            }
                        </Select>
                    </FormControl>

                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CountrySelect);



// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/CFILevel4Select.js